import { ControllerStatus } from "@/types/simulInter";
import http from "../services/http";

interface RecordList {
  pageIndex: number; // 页码
  totalPages: number; // 总页码
  data: Array<SimpleRecord>;
  empty: boolean;
}

export interface SimpleRecord {
  createdDate: string; // 创建时间
  duration: null; // 录制时长（单位：秒）
  streamName: string; // 流名称
  summaryRecord: SummaryRecord; // 总结记录
  title: string; // 会议名称
  collect: boolean; // 是否收藏
  origin: string; // 来源
  userId: string; // 用户id
  isDeleted: boolean | null; // 是否已删除
  subscribed: boolean | null; // 是否订阅
  allowBackUp: boolean; // 是否允许备份
  shareForMe: boolean; // 是否与我分享记录
  shareUrl: string | null; // 分享短链
  viewed: boolean | undefined; // 是否查看过
  coverUrl?: string; // 封面图
  source: string; // 会议总结来源:1.LIVE实时录制；2.FILE文件导入;DEVICE_CONTROLLER设备控制
  reportFileKey: string; // 发言稿文件key
  controllerStatus: ControllerStatus; // 控制状态：1-完成，2-待录制，3正在录制
  reportFirstSentence?: string | null; // 报告第一句话
  boardSn?: string; // 设备序列号
}

interface SummaryRecord {
  keyWords: Array<KeyWords> | null; // 关键词
  meetingSummary: string[] | null; // 会议概要
}

export interface KeyWords {
  key: string;
  count: number;
}

export async function getRecordList(app: boolean = false, markingType: string, page: number, title: string | null = null, size: number = 20) {
  const t = title ? `&title=${title}&page=${page}&size=${size}` : `&page=${page}&size=${size}`;
  const res = await http.get<RecordList>(`/api/auth/live-record/page?markingType=${markingType}${t}${app ? `&app=true` : ''}`);
  return res.data;
}

export async function shareRecord(id: string) {
  try {
    await http.post<boolean>("/api/auth/live-record/share", { id });
    return true;
  } catch (e) {
    console.log("shareRecord error >>>> ", e);
    return false;
  }
}

export async function RenameRecord(streamName: string, title: string) {
  try {
    await http.post<boolean>("/api/auth/live-record/rename", {
      streamName,
      title,
    });
    return true;
  } catch (e) {
    console.log("collectRecord error >>>> ", e);
    return false;
  }
}

export async function collectRecord(streamName: string): Promise<boolean> {
  try {
    await http.post<boolean>("/api/auth/live-record/collect", { streamName });
    return true;
  } catch (e) {
    console.log("collectRecord error >>>> ", e);
    return false;
  }
}


export async function collectShareRecord(streamName: string): Promise<boolean> {
  try {
    await http.post<boolean>("/api/auth/live-record/share/collect", { streamName });
    return true;
  } catch (e) {
    console.log("collectShareRecord error >>>> ", e);
    return false;
  }
}

export async function cancelCollectRecord(streamName: string) {
  try {
    await http.post<boolean>("/api/auth/live-record/collect/cancel", {
      streamName,
    });
    return true;
  } catch (e) {
    console.log("cancleCollectRecord error >>>> ", e);
    return false;
  }
}

export async function cancelCollectShareRecord(streamName: string) {
  try {
    await http.post<boolean>("/api/auth/live-record/share/collect/cancel", {
      streamName,
    });
    return true;
  } catch (e) {
    console.log("cancelCollectShareRecord error >>>> ", e);
    return false;
  }
}

export async function deleteRecord(streamName: string) {
  try {
    await http.delete(`/api/auth/live-record?streamName=${streamName}`);
    return true;
  } catch (e) {
    console.log("deleteRecord error >>>> ", e);
    return false;
  }
}

export async function deleteShareRecord(streamName: string) {
  try {
    await http.delete(`/api/auth/live-record/share/subscribe/delete?streamName=${streamName}`);
    return true;
  } catch (e) {
    console.log("deleteShareRecord error >>>> ", streamName, e);
    return false;
  }
}

// 查询记录是否结束
export async function isRecordEnd(streamName: string) {
  try {
    const res = await http.get<{ isStop: boolean }>(`/api/auth/record-server/meeting/record?streamName=${streamName}`);
    console.log("isRecordEnd res >>>> ", res.data);
    return res.data.isStop;
  } catch (e) {
    console.log("isRecordEnd error >>>> ", streamName, e);
    return false;
  }
}